import { useTranslation } from 'react-i18next';

import { TOptions } from 'i18next';

import { getMappedTranslation } from 'utility/Translate/mappedTranslation';

export function useMappedTranslation<
    MapKeyType extends number | string | symbol
>(
    map: Partial<Record<MapKeyType | '', string>>,
    value: MapKeyType | undefined,
    fallback?: string,
    options?: TOptions
) {
    const { t } = useTranslation();

    return getMappedTranslation(map, value, t, fallback, options);
}
